import React, { useEffect, useState } from "react";
import { Input } from "@mui/material";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { useDispatch, useSelector } from "react-redux";
import { Avatar } from "antd";
import { getUser } from "../../../helpers/sessionStorageHelper";
import { saveProfile } from "../../../dux/profile";
import { apiCallComplete, isSaveProfilePending } from "../../../dux/apiStatus";
import styles from "./MyProfile.module.css";
import LoaderForButton from "../../shared/UI/LoaderForButton";

const MyProfile = () => {
  const user = getUser();

  // Handle different possible property names from the backend
  const firstName = user.first_name || user.firstName || "";
  const lastName = user.last_name || user.lastName || "";
  const emailAddress = user.email_address || user.emailAddress || "";
  const mobileNumber = user.mobile_number || user.mobileNumber || "";

  const dispatch = useDispatch();
  const [fname, setfname] = useState(firstName);
  const [lname, setlname] = useState(lastName);
  const [email, setemail] = useState(emailAddress);
  const isSavingProfile = useSelector(isSaveProfilePending);

  const reset = () => {
    setfname(firstName);
    setlname(lastName);
    setemail(emailAddress);
  };

  const saveHandler = () => {
    dispatch(
      saveProfile({
        firstName: fname,
        lastName: lname,
        emailAddress: email,
        mobileNumber,
      })
    );
  };

  useEffect(() => {
    // Initialize state with user data when component mounts
    setfname(firstName);
    setlname(lastName);
    setemail(emailAddress);

    return () => {
      dispatch(apiCallComplete({ api: "saveProfile" }));
    };
  }, [firstName, lastName, emailAddress, dispatch]);

  const fnameChangeHandler = ({ target: { value } }) => {
    setfname(value);
  };

  const lnameChangeHandler = ({ target: { value } }) => {
    setlname(value);
  };

  const emailChangeHandler = ({ target: { value } }) => {
    setemail(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.profile}>
        <Avatar
          icon={<PersonRoundedIcon style={{ width: 200, height: 200 }} />}
          style={{ width: 200, height: 200 }}
        >
          J
        </Avatar>

        <div className={styles.number}>{mobileNumber}</div>
      </div>
      <Input
        value={fname}
        onChange={fnameChangeHandler}
        className={styles.inputField}
        placeholder="First Name"
      />
      <Input
        value={lname}
        onChange={lnameChangeHandler}
        className={styles.inputField}
        placeholder="Last Name"
      />
      <Input
        type="email"
        value={email}
        onChange={emailChangeHandler}
        className={styles.inputField}
        placeholder="Email"
      />

      <div className={styles.btnContainer}>
        <button
          className={styles.savebtn}
          onClick={saveHandler}
          disabled={!(email && fname && lname) || isSavingProfile}
        >
          {isSavingProfile ? <LoaderForButton /> : "SAVE"}
        </button>

        <button className={styles.btn} onClick={reset}>
          RESET
        </button>
      </div>
    </div>
  );
};

export default MyProfile;
